import React from 'react';
import {Column, useTable} from 'react-table';
import classNames from 'classnames';

interface PlainGridProps<T extends { [key: string]: unknown } = { [key: string]: unknown }> {
  columns: Column[];
  data: T[];
  customTableStyles?: string;
}

const PlainGrid = ({
                     columns,
                     data,
                     customTableStyles = ''
                   }: PlainGridProps) => {
  const tableInstance = useTable({columns, data});

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = tableInstance;

  return (
    <div
      style={{
        maxHeight: "calc(100vh - 200px)",
        overflowY: "auto",
      }}
    >
      <table {...getTableProps()}
             className={classNames(`table table-head-custom table-vertical-center infinite-scroll-table bg-white`, customTableStyles)}
      >
        <thead className="sticky-header head custom-thead">
        {headerGroups.map(headerGroup => (
          <tr {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map(column => (
              <th {...column.getHeaderProps()} id="custom-brand-color-tableHead">{column.render('Header')}</th>
            ))}
          </tr>
        ))}
        </thead>
        <tbody {...getTableBodyProps()} className="body">
        {rows.map((row, i) => {
          prepareRow(row);
          return (
            <tr {...row.getRowProps()} key={i}>
              {row.cells.map(cell => {
                return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>;
              })}
            </tr>
          );
        })}
        </tbody>
      </table>
    </div>
  );
};

export default PlainGrid;